import { products } from '../../constants';
import { isAnnually } from './flexBillingFrequency';

type CurrentSubscription = {
  family?: string | null;
  freeTrial?: boolean;
  billingFrequency?: string | null;
  price?: number | string | null;
};

type UpgradeOffer = {
  family?: string | null;
  terms?: Array<{ billingFrequency?: string | null } | null>;
};

export const isPaidAnnualIdentityToMonthlyCreditExpert = ({
  currentSubscription,
  upgradeOffer,
  isFlexFlow,
}: {
  currentSubscription?: CurrentSubscription | null;
  upgradeOffer?: UpgradeOffer | null;
  isFlexFlow?: boolean;
}): boolean => {
  if (!isFlexFlow) {
    return false;
  }

  const targetFrequency = upgradeOffer?.terms?.[0]?.billingFrequency;

  return (
    currentSubscription?.family === products.identity &&
    currentSubscription?.freeTrial !== true &&
    isAnnually(currentSubscription?.billingFrequency) &&
    upgradeOffer?.family === products.credit_expert &&
    Boolean(targetFrequency) &&
    !isAnnually(targetFrequency)
  );
};

export const formatRefundAmount = (price?: number | string | null): string | null => {
  if (price === null || price === undefined || price === '') {
    return null;
  }

  const amount = Number(price);
  return Number.isFinite(amount) ? `£${amount.toFixed(2)}` : null;
};
